<script>
//--------------------------------------------------
// imported classes
//--------------------------------------------------
import { DropdownMenu, DropdownItem, Icon, Toast, Popover } from 'vant'

//--------------------------------------------------
// global registration
//--------------------------------------------------

//--------------------------------------------------
// main script
//--------------------------------------------------
export default {
    //--------------------------------------------------
	// component extends
	//--------------------------------------------------

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-dropdown-menu': DropdownMenu,
        'van-dropdown-item': DropdownItem,
        'van-icon': Icon,
        'van-popover': Popover,
    },

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
	data() {
        return {
            role: 'skater',
            game: {
                seasons: [],
                leagues: [],
                groups: [],
                games: [],
            },
            filter: {
                season: '',
                league: '',
                group: '',
            },
            isLoading: true,
            locale: {},
            popovers: {}
        }
	},

    //--------------------------------------------------
    // component life cycle trigger
    //--------------------------------------------------

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        seasonOptions() {
            // console.log('seasonOptions', this.locale, this.game.seasons)
            let options = []
            if (this.locale) {
                options.push({text: this.locale['select-season-placeholder'], value: ''})
                if (this.game.seasons.length) {
                    options = options.concat(this.game.seasons)
                }
            }
            return options
        },
        leagueOptions() {
            let options = []
            if (this.locale) {
                options.push({text: this.locale['select-league-placeholder'], value: ''})
                if (this.game.leagues.length) {
                    options = options.concat(this.game.leagues)
                }
            }
            return options
        },
        groupOptions() {
            let options = []
            if (this.locale) {
                options.push({text: this.locale['select-group-placeholder'], value: ''})
                if (this.filter.season != '' && this.filter.league != '') {
                    options = options.concat(this.game.groups)
                }
            }
            return options
        },
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        //--------------------------------------------------
        // handler method
        //--------------------------------------------------
        showToast(text) {
            Toast(text)
        },
        onSeasonChange() {
            this.updateQuery()
        },
        onLeagueChange() {
            this.updateQuery()
        },
        onGroupChange() {
            this.updateQuery()
        },
        onServiceBtnClick() {
            // console.log('onServiceBtnClick')
            this.$emit('custom-event', {
                type: 'popup-service'
            })
        },
        onGroupBtnClick(gameId) {
            console.log('onGroupBtnClick', gameId)
            this.$emit('custom-event', {
                type: 'go-detail',
                data: {
                    type: 'group',
                    gameId: gameId
                }
            })
        },
        onGameBtnClick(gameId) {
            this.$emit('custom-event', {
                type: 'go-detail',
                data: {
                    type: 'game',
                    gameId: gameId,
                    current: 1
                }
            })
        },

        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        updateQuery() {
            this.$emit('custom-event', {
                type: 'updateQuery',
                data: {
                    query: {
                        season: this.filter.season,
                        league: this.filter.league,
                        group: this.filter.group,
                    },
                }
            })
        },
        getActions(text) {
            return [
                { text: this.locale[text] }
            ]
        }
    }
}
</script>

<template>
    <!-- component -->
    <div class="report-games">
        <van-dropdown-menu>
            <van-dropdown-item 
                v-model="filter.season" 
                :options="seasonOptions"
                @change="onSeasonChange"
            />
            <van-dropdown-item 
                v-model="filter.league" 
                :options="leagueOptions"
                @change="onLeagueChange"
            />
            <van-dropdown-item 
                v-model="filter.group" 
                :options="groupOptions"
                @change="onGroupChange"
            />
        </van-dropdown-menu>
        <div v-if="!isLoading">
            <div v-if="game.games.length > 0">
                <table v-if="role == 'skater'" class="table text-center ">
                    <thead class="main-color normal-text">
                        <tr>
                            <th>{{ locale['short-date'] }}</th>
                            <th>{{ locale['opponent'] }}</th>
                            <th>{{ locale['score'] }}</th>
                            <th>
                                <van-popover
                                    v-model="popovers['g']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[20, 6]"
                                    placement="top-end"
                                    :actions="getActions('goals')"
                                >
                                    <template #reference>
                                        <span>{{ locale['goals-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>
                                <van-popover
                                    v-model="popovers['a']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[20, 6]"
                                    placement="top-end"
                                    :actions="getActions('assists')"
                                >
                                    <template #reference>
                                        <span>{{ locale['assists-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>
                                <van-popover
                                    v-model="popovers['p']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[20, 6]"
                                    placement="top-end"
                                    :actions="getActions('points')"
                                >
                                    <template #reference>
                                        <span>{{ locale['points-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>
                                <van-popover
                                    v-model="popovers['pim']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[15, 6]"
                                    placement="top-end"
                                    :actions="getActions('penalty-mins')"
                                >
                                    <template #reference>
                                        <span>{{ locale['penalty-mins-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>
                                <van-popover
                                    v-model="popovers['ppg']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[10, 6]"
                                    placement="top-end"
                                    :actions="getActions('power-play-goals')"
                                >
                                    <template #reference>
                                        <span>{{ locale['power-play-goals-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>
                                <van-popover
                                    v-model="popovers['shg']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[10, 6]"
                                    placement="top-end"
                                    :actions="getActions('short-handed-goals')"
                                >
                                    <template #reference>
                                        <span>{{ locale['short-handed-goals-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>
                                <van-popover
                                    v-model="popovers['psg']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[10, 6]"
                                    placement="top-end"
                                    :actions="getActions('penalty-shot-goals')"
                                >
                                    <template #reference>
                                        <span>{{ locale['penalty-shot-goals-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>
                                <van-popover
                                    v-model="popovers['otg']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[10, 6]"
                                    placement="top-end"
                                    :actions="getActions('overtime-goals')"
                                >
                                    <template #reference>
                                        <span>{{ locale['overtime-goals-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>
                                <van-popover
                                    v-model="popovers['gwg']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[10, 6]"
                                    placement="top-end"
                                    :actions="getActions('game-winning-goals')"
                                >
                                    <template #reference>
                                        <span>{{ locale['game-winning-goals-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>
                                <van-popover
                                    v-model="popovers['sos']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[10, 6]"
                                    placement="top-end"
                                    :actions="getActions('shootout-shots')"
                                >
                                    <template #reference>
                                        <span>{{ locale['shootout-shots-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>
                                <van-popover
                                    v-model="popovers['sog']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[10, 6]"
                                    placement="top-end"
                                    :actions="getActions('shootout-goals')"
                                >
                                    <template #reference>
                                        <span>{{ locale['shootout-goals-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>{{ locale['detail'] }}</th>
                        </tr>
                    </thead> 
                    <tbody class="main-secondary-color normal-text">
                        <tr v-for="(item, index) in game.games" :key="index">
                            <td v-if="item.isGroup" colspan="14" class="group-label text-left main-color">{{ item.label }}</td>
                            <td v-if="item.isGroup" class="main-color">
                                <van-icon name="more-o" @click="onGroupBtnClick(item.gameId)"/>
                            </td>
                            <td v-if="!item.isGroup">{{ item.shortDate }}</td>
                            <td v-if="!item.isGroup">{{ item.opp }}</td>
                            <td v-if="!item.isGroup">{{ item.score }}</td>
                            <td v-if="!item.isGroup">{{ item.g }}</td>
                            <td v-if="!item.isGroup">{{ item.a }}</td>
                            <td v-if="!item.isGroup">{{ item.p }}</td>
                            <td v-if="!item.isGroup">{{ item.pim }}</td>
                            <td v-if="!item.isGroup">{{ item.ppg }}</td>
                            <td v-if="!item.isGroup">{{ item.shg }}</td>
                            <td v-if="!item.isGroup">{{ item.psg }}</td>
                            <td v-if="!item.isGroup">{{ item.otg }}</td>
                            <td v-if="!item.isGroup">{{ item.gwg }}</td>
                            <td v-if="!item.isGroup">{{ item.sos }}</td>
                            <td v-if="!item.isGroup">{{ item.sog }}</td>
                            <td v-if="!item.isGroup">
                                <van-icon name="more-o" @click="onGameBtnClick(item.gameId)"/>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table v-else  class="table text-center ">
                    <thead class="main-color normal-text">
                        <tr>
                            <th>{{ locale['short-date'] }}</th>
                            <th>{{ locale['opponent'] }}</th>
                            <th>{{ locale['score'] }}</th>
                            <th>
                                <van-popover
                                    v-model="popovers['ga']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[18, 6]"
                                    placement="top-end"
                                    :actions="getActions('goals-against')"
                                >
                                    <template #reference>
                                        <span>{{ locale['goals-against-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>
                                <van-popover
                                    v-model="popovers['ppga']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[6, 6]"
                                    placement="top-end"
                                    :actions="getActions('power-play-goals-against')"
                                >
                                    <template #reference>
                                        <span>{{ locale['power-play-goals-against-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>
                                <van-popover
                                    v-model="popovers['shga']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[6, 6]"
                                    placement="top-end"
                                    :actions="getActions('short-handed-goals-against')"
                                >
                                    <template #reference>
                                        <span>{{ locale['short-handed-goals-against-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>
                                <van-popover
                                    v-model="popovers['psga']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[6, 6]"
                                    placement="top-end"
                                    :actions="getActions('penalty-shot-goals-against')"
                                >
                                    <template #reference>
                                        <span>{{ locale['penalty-shot-goals-against-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>
                                <van-popover
                                    v-model="popovers['otga']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[6, 6]"
                                    placement="top-end"
                                    :actions="getActions('overtime-goals-against')"
                                >
                                    <template #reference>
                                        <span>{{ locale['overtime-goals-against-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>
                                <van-popover
                                    v-model="popovers['gwga']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[6, 6]"
                                    placement="top-end"
                                    :actions="getActions('game-winning-goals-against')"
                                >
                                    <template #reference>
                                        <span>{{ locale['game-winning-goals-against-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>
                                <van-popover
                                    v-model="popovers['sosa']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[0, 6]"
                                    placement="top-end"
                                    :actions="getActions('shootout-shots-against')"
                                >
                                    <template #reference>
                                        <span>{{ locale['shootout-shots-against-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>
                                <van-popover
                                    v-model="popovers['soga']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[0, 6]"
                                    placement="top-end"
                                    :actions="getActions('shootout-goals-against')"
                                >
                                    <template #reference>
                                        <span>{{ locale['shootout-goals-against-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>
                                <van-popover
                                    v-model="popovers['sosv']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[0, 6]"
                                    placement="top-end"
                                    :actions="getActions('shootout-saves')"
                                >
                                    <template #reference>
                                        <span>{{ locale['shootout-saves-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>
                                <van-popover
                                    v-model="popovers['sosvp']"
                                    trigger="click"
                                    theme="dark"
                                    :offset="[0, 6]"
                                    placement="top-end"
                                    :actions="getActions('shootout-saves-percentage')"
                                >
                                    <template #reference>
                                        <span>{{ locale['shootout-saves-percentage-i'] }}</span>
                                    </template>
                                </van-popover>
                            </th>
                            <th>{{ locale['detail'] }}</th>
                        </tr>
                    </thead> 
                    <tbody class="main-secondary-color normal-text">
                        <tr v-for="(item, index) in game.games" :key="index">
                            <td v-if="item.isGroup" colspan="13" class="group-label text-left main-color">{{ item.label }}</td>
                            <td v-if="item.isGroup" class="main-color">
                                <van-icon name="more-o" @click="onGroupBtnClick(item.gameId)"/>
                            </td>
                            <td v-if="!item.isGroup">{{ item.shortDate }}</td>
                            <td v-if="!item.isGroup">{{ item.opp }}</td>
                            <td v-if="!item.isGroup">{{ item.score }}</td>
                            <td v-if="!item.isGroup">{{ item.ga }}</td>
                            <td v-if="!item.isGroup">{{ item.ppga }}</td>
                            <td v-if="!item.isGroup">{{ item.shga }}</td>
                            <td v-if="!item.isGroup">{{ item.psga }}</td>
                            <td v-if="!item.isGroup">{{ item.otga }}</td>
                            <td v-if="!item.isGroup">{{ item.gwga }}</td>
                            <td v-if="!item.isGroup">{{ item.sosa }}</td>
                            <td v-if="!item.isGroup">{{ item.soga }}</td>
                            <td v-if="!item.isGroup">{{ item.sosv }}</td>
                            <td v-if="!item.isGroup">{{ item.sosvp }}</td>
                            <td v-if="!item.isGroup">
                                <van-icon name="more-o" @click="onGameBtnClick(item.gameId)"/>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else>
                <div class="service-unit justify-center">
                    <div class="wm-wrapper">
                        <img src="@/fcl/assets/user/player-stats-game-wm.png" style="width: 345px; height: 131px;"/>
                    </div>
                    <div class="float-layer absolute">
                        <div class="lock-wrapper text-center">
                            <img src="@/fcl/assets/user/lock-symbol.png" style="width: 39px; height: 39px;" />
                        </div>
                        <div class="prompt-hint text-center">
                            <span class="block text-title">{{ locale['launch-service'] }}</span>
                            <span class="block normal-text">{{ locale['player-stats-game-feature'] }}</span>
                        </div>
                    </div>
                </div>
                <div class="t-wide-margin l-wide-margin">
                    <div class="service-button btn justify-center vertical-center" @click="onServiceBtnClick">
                        <span class="color-white text-title">{{ locale['data-service-launch'] }}</span>
                        <span class="l-outer-margin"><img src="@/fcl/assets/user/vip-symbol.png" style="height: 12px; width: 16px;"/></span>
                    </div>
                </div>
            </div>
        </div>
        <van-overlay 
            :show="isLoading" 
            class="vertical-center justify-center"
        >
            <van-loading />
        </van-overlay>
    </div>
</template>

<style scoped>
.service-unit {
    height: 180px;
}
.service-button {
    height: 45px;
    width: 346px;
    background: #E1671C;
}
.float-layer {
    margin-top: 86px;
}
table {
    width: 100%;
    overflow: auto;
    display: block;
    max-height: 500px;
    table-layout: fixed;
    border-collapse: collapse;
}
thead {
    position: sticky;
    top: -1px;
    background: white;
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1);
    z-index: 1;
}
thead th:first-child,
tbody td:first-child {
    position: sticky;
    left: 0;
    z-index: 0;
    background-color: inherit;
}
thead th:nth-child(2),
tbody td:nth-child(2) {
    position: sticky;
    left: 44px;
    z-index: 0;
    background-color: inherit;
}
th, td {
    white-space: nowrap;
    padding: 4px;
}
tr:nth-child(even) {
    background-color: #F2F2F2;
 }
tr:nth-child(odd) {
    background-color: #FFF;
}
tr {
    line-height: 1.6;
}
td.group-label {
    line-height: 2;
}
thead tr {
    line-height: 2.4;
}
</style>